import { hashKey, type QueryClient } from '@tanstack/react-query';
import { currentUserQueryKey } from '@/hooks/useCurrentUserQuery';

const currentUserQueryHash = hashKey(currentUserQueryKey);

/**
 * After 401/refresh failure, drop cached app data without destroying the
 * current-user observer. `queryClient.clear()` during the bootstrap query
 * leaves that observer pending+idle, so the splash never yields to login.
 */
export function resetClientAfterAuthFailure(queryClient: QueryClient): void {
  queryClient.setQueryData(currentUserQueryKey, null);
  queryClient.removeQueries({
    predicate: (query) => hashKey(query.queryKey) !== currentUserQueryHash,
  });
}

/** Splash while the session probe is in-flight or backing off — not when idle. */
export function shouldShowAuthSplash({
  isPending,
  fetchStatus,
  isLogoutPending,
}: {
  isPending: boolean;
  fetchStatus: 'idle' | 'fetching' | 'paused';
  isLogoutPending: boolean;
}): boolean {
  return isLogoutPending || (isPending && fetchStatus !== 'idle');
}
